/**
 * This defines a set of constants used by the wvre-nav-list component in order to describe the position of the navigation list .
 */
export enum Alignment {
  LEFT = 'LEFT', RIGHT = 'RIGHT', CENTER = 'CENTER'
}
